import {register} from '../vendor/theme-scripts/theme-sections';
import {ajaxify} from '../features/infinity-scroll';

register('collection-grid', [ajaxify]);
